export default "__VITE_ASSET__CzIjr$01__"